<template>
  <div>
    <div class="container-fluid">
      <div class="row mt-5">
        <div class="col-md-12">
          <vs-table stripe class="w-full" :data="[1]">
            <template slot="thead">
              <vs-th class="colors">{{$t("productName")}}</vs-th>
              <vs-th class="colors">{{$t("productCode")}}</vs-th>
              <vs-th class="colors">{{$t("barcod")}}</vs-th>
              <vs-th class="colors">{{$t("categoryName")}}</vs-th>
              <vs-th class="colors">{{$t("width")}}</vs-th>
              <vs-th class="colors">{{$t("height")}}</vs-th>
              <vs-th class="colors">{{$t("frameCount")}}</vs-th>
            </template>
            <template slot-scope="{}">
              <vs-tr class="table-line">
                <vs-td>{{ ready.productName }}</vs-td>
                <vs-td>{{ ready.productCode }}</vs-td>
                <vs-td>{{ ready.productBarcode }}</vs-td>
                <vs-td>{{ ready.categoryName }}</vs-td>
                <vs-td>{{ ready.width }}</vs-td>
                <vs-td>{{ ready.height }}</vs-td>
                <vs-td>{{ ready.frameCount }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <div class="row" style="margin-top:50px">
        <div class="col-md-6">
          <vs-collapse type="border">
            <vs-collapse-item icon-arrow="arrow_downward" open>
              <div slot="header">{{$t('features')}}</div>
              <vs-table
                max-items="20"
                stripe
                :data="obj.selectedPropertyId"
                class="w-full"
                maxHeight="200px"
                style="height:200px"
              >
                <template slot="thead">
                  <vs-th class="table-rows colors" sort-key="featureName">{{$t("featureName")}}</vs-th>
                  <vs-th class="table-rows colors" sort-key="value">{{$t("value")}}</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr class="table-line" :key="indextr" v-for="(item, indextr) in data">
                    <vs-td class="table-rows" :data="item.propertyName">{{ item.propertyName }}</vs-td>
                    <vs-td class="table-rows" :data="item.value">{{ item.value }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-collapse-item>
          </vs-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../../http/http-helper";

export default {
  props: ["id"],
  data() {
    return {
      value: this.id,
      categories: [],
      properties: [],
      files: [],
      obj: {
        selectedCategoryId: [],
        selectedPropertyId: [],
        selectedProductFiles: [],
      },
      ready: {
        productName: "",
        productCode: "",
        productBarcode: "",
        categoryName: "",
        frameCount: "",
        width: "",
        height: "",
      },
    };
  },
  methods: {
    getDetailCategories() {
      this.obj.selectedCategoryId = [];
      this.obj.selectedPropertyId = [];
      this.obj.selectedProductFiles = [];
      http
        .get(`/products/getbyproductid?productId=${this.value}`)
        .then((response) => {
          response.productProperties.forEach((element) => {
            this.obj.selectedPropertyId.push({
              id: element.propertyId,
              propertyName: element.propertyName,
              value: element.value,
            });
          });
          response.productFiles.forEach((element) => {
            this.obj.selectedProductFiles.push(element);
          });
          this.$emit("alldata", response.productSettings);
          this.$emit("getData", response.productFiles);
          this.$emit("headerName", response.name);
          this.$emit("clientId", response.clientViewCode);
          this.ready.productName = response.name;
          this.ready.productCode = response.productCode;
          this.ready.productBarcode = response.productBarcode;
          this.ready.categoryName = response.categoryName;
          this.ready.width = response.width;
          this.ready.height = response.height;
          this.ready.frameCount = response.frameCount;
        });
    },
  },
  created() {
    this.getDetailCategories();
  },
};
</script>

<style scoped>
.check {
  width: 80%;
}
.width {
  width: 60px !important;
}
.colors {
  background-color: rgb(211, 211, 211);
}
</style>